import { useEffect, useState } from "react";
import Table from "../../../../components/common/table/Table";
import Button from "../../../../components/common/ui/Button";
import { useDispatch, useSelector } from "react-redux";
// import { memberActions } from "../../../../_store/Admin/members.slice";
import deleteicon from "../../../../assets/svg/delete-icon.svg";
import editIcon from "../../../../assets/svg/edit-icon.svg";
import warningIcon from "../../../../assets/constant-contact-warning.png";
import CustomLoader from "../../../../components/common/ui/Loader";
import TextInput from "../../../../components/common/ui/Inputs/TextInput";
import RadioInput from "../../../../components/common/ui/Inputs/RadioInput";
import { history } from "../../../../_helpers/history";
import { committeeActions } from "../../../../_store/committee.slice";
import { SelectInput } from "../../../../components/common/ui/Inputs";
import { masterActions } from "../../../../_store/master.slice";

function Committee() {
  const dispatch = useDispatch();
  const { committeeForm, committeeList, loading } = useSelector(
    (x) => x?.committee,
  );
  const { getAllActiveUsersForSearchResponse } = useSelector((x) => x?.master);
  const { ActiveStatus } = useSelector((x) => x?.dropDown);
  const list = committeeList?.data?.committees;
  const totalCount = committeeList?.data?.totalItems || 0;
  const [filters, setFilters] = useState({
    committeeName: "",
    committeeAdmin: "",
    status: true,
  });

  const [apiParams, setApiParams] = useState(
    `?page=${1}&limit=${10}&status=${true}`,
  );
  const [pageNo, setPageNo] = useState(1);
  const [rowCountPerPage, setRowCountPerPage] = useState(10);

  useEffect(() => {
    getUserList();
  }, []);

  const getUserList = () => {
    dispatch(masterActions?.getAllActiveUsersForSearch());
  };

  const columns = [
    {
      name: "Committee Name",
      key: "committeeName",
      selector: (row) => row.committeeName,
      sortable: true,
      // width: "272px",
    },
    // {
    //   name: "Committee Chair",
    //   key: "committeeAdmin",
    //   // selector: (row) =>
    //   //   row.committeeAdmin[0]?.firstName + " " + row.committeeAdmin[0]?.lastName,
    //   // sortable: true,
    //   // width: "400px",
    //   selector: (row) => {
    //     if (
    //       Array.isArray(row.committeeAdmin) &&
    //       row.committeeAdmin.length > 0
    //     ) {
    //       const first = `${row.committeeAdmin[0].firstName} ${row.committeeAdmin[0].lastName}`;
    //       return row.committeeAdmin.length > 1 ? (
    //         <div
    //           title={row.committeeAdmin
    //             .map((member) => `${member.firstName} ${member.lastName}`)
    //             .join(", ")}
    //         >
    //           {first} , ...
    //         </div>
    //       ) : (
    //         first
    //       );
    //     }
    //     return "-";
    //   },
    // },
    {
      name: "Committee Chair",
      key: "committeeAdmin",
      selector: (row) => {
        if (
          Array.isArray(row?.committeeAdmin) &&
          row?.committeeAdmin?.length > 0
        ) {
          const firstMember = row?.committeeAdmin[0];
          const first = `${firstMember?.firstName} ${firstMember?.lastName}`;

          return row?.committeeAdmin?.length > 1 ? (
            <div
              title={row?.committeeAdmin
                .map((member) => `${member?.firstName} ${member?.lastName}`)
                .join(", ")}
            >
              {first} , ...
            </div>
          ) : (
            first
          );
        }
        return "-"; // fallback when committeeAdmin is empty or undefined
      },
    },

    {
      name: "Status",
      key: "lastName",
      selector: (row) => (row.status ? "Active" : "Inactive"),
      sortable: true,
    },
    {
      // width: "80px",
      name: "Actions",
      key: "actions",
      cell: (row) => (
        <>
          <div className="d-flex gap-2">
            <img
              src={editIcon}
              title="Edit"
              alt="edit-icon"
              aria-hidden="true"
              className="cursor-pointer sbpc-icon-size"
              onClick={() => {
                handleEditCommittee(row);
              }}
            />
          </div>
          {row?.ccIsVerified === false && (
            <div className="d-flex gap-2">
              <img
                src={warningIcon}
                title="This committee is not added in CC. Please reconnect CC and update to reflect the changes"
                alt="warning-icon"
                aria-hidden="true"
                className="sbpc-icon-size"
              />
            </div>
          )}
        </>
      ),
      sortable: false,
    },
  ];

  const handleEditCommittee = (row) => {
    history?.navigate("/Admin/Committee/createOrEdit", {
      state: { committeeID: row?._id, committeeAdmin: row?.committeeAdmin },
    });
  };

  useEffect(() => {
    const params = apiParams;
    dispatch(committeeActions?.getCommitteeList(params));
  }, []);

  useEffect(() => {
    const query = new URLSearchParams({
      page: "1",
      limit: "10",
      ...Object.fromEntries(
        Object.entries(filters).filter(
          ([_, v]) => v !== "" && v !== null && v !== undefined,
        ),
      ),
    }).toString();

    setApiParams(`?${query}`);
  }, [filters]);

  const handleSearchChange = (e, select) => {
    if (select) {
      setFilters((prev) => ({
        ...prev,
        [select]: e?.value === undefined ? null : e?.value,
      }));
      return;
    }
    const { name, value, type } = e.target;
    if (value.startsWith(" ")) return;
    setFilters((prev) => ({
      ...prev,
      [name]: type === "radio" ? (value === "true" ? true : false) : value,
    }));
  };

  // const handleRowPerPage = (page) => {
  //   const updatedParams = apiParams.replace(/&limit=\d+/, `&limit=${page}`);
  //   setApiParams(updatedParams);
  //   dispatch(committeeActions?.getCommitteeList(updatedParams));
  //   setRowCountPerPage(page);
  //   setPageNo(1);
  // };

  const handleRowPerPage = (rowsPerPage) => {
    const params = new URLSearchParams(apiParams);

    params.set("page", "1"); // Reset page
    params.set("limit", rowsPerPage);

    const updatedParams = `?${params.toString()}`;

    setApiParams(updatedParams);
    setPageNo(1);
    setRowCountPerPage(rowsPerPage);

    dispatch(committeeActions?.getCommitteeList(updatedParams));
  };

  const handlePageChange = (page) => {
    const updatedParams = apiParams.replace(/([?&])page=\d+/, `$1page=${page}`);
    setApiParams(updatedParams);
    dispatch(committeeActions?.getCommitteeList(updatedParams));
    setPageNo(page);
  };

  const handleSearchSubmit = (e) => {
    e?.preventDefault();
    setPageNo(1);
    setRowCountPerPage(10);
    dispatch(committeeActions?.getCommitteeList(apiParams));
  };

  const handleFormReset = (e) => {
    e?.preventDefault();
    setFilters({
      committeeName: "",
      status: true,
    });
    const params = `?page=${1}&limit=${10}&status=${true}`;
    setApiParams(params);
    setPageNo(1);
    setRowCountPerPage(10);
    dispatch(committeeActions?.getCommitteeList(params));
  };

  if (loading) return <CustomLoader />;

  return (
    <>
      <div className="d-flex flex-wrap justify-content-between align-items-center">
        <h1 className="header-color">Committees</h1>
        <Button
          status="secondary"
          label="Create Committee"
          onClick={() => {
            history?.navigate("/Admin/Committee/CreateOrEdit", {
              state: { committeeID: 0 },
            });
          }}
        />
      </div>
      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color border-dotted p-3 border-bottom">
          Search Committee
        </h1>
        <form
          className="p-3 row"
          onSubmit={(e) => {
            handleSearchSubmit(e);
          }}
          onReset={(e) => {
            handleFormReset(e);
          }}
        >
          <div className="col-md-4">
            <TextInput
              label="Name"
              placeholder="Committee name"
              name="committeeName"
              handleChange={handleSearchChange}
              value={filters?.committeeName}
            />
          </div>
          <div className="col-md-4">
            <SelectInput
              options={getAllActiveUsersForSearchResponse?.data?.formattedUsers}
              name="committeeAdmin"
              id="committeeAdmin"
              label="Committee Chair"
              handleChange={(e) => handleSearchChange(e, "committeeAdmin")}
              value={filters?.committeeAdmin}
            />
          </div>
          <div className="col-md-4">
            <RadioInput
              name="status"
              id="status"
              label="Status"
              options={ActiveStatus}
              handleChange={(e) => handleSearchChange(e)}
              selectedValue={filters?.status}
            />
          </div>

          <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
            <Button status="secondary" label="Search" type="submit" />
            <Button status="reset" label="Reset" type="reset" />
          </div>
        </form>
      </div>

      <div className="card shadow-sm b-r-all border border-dark-grey mt-3 w-100">
        <h1 className="m-0 search-header-color p-3 ">Committee List</h1>
        <Table
          columns={columns}
          data={list}
          pagination
          onChangeRowsPerPage={handleRowPerPage}
          onChangePage={handlePageChange}
          totalRowCount={totalCount}
          currentPage={pageNo}
          paginationPerPage={rowCountPerPage}
        />
      </div>
    </>
  );
}

export default Committee;
